import { TransactionBase } from '@safe-global/types-kit'
import { PreparedTransaction } from 'thirdweb'
import { resolvePromisedValue } from 'thirdweb/utils'

export const resolveThirdwebTransaction = async (
  thirdwebTx?: PreparedTransaction
): Promise<TransactionBase | null> => {
  if (!thirdwebTx) return null

  const to = await resolvePromisedValue(thirdwebTx.to)
  const data = await resolvePromisedValue(thirdwebTx.data)
  const value = await resolvePromisedValue(thirdwebTx.value)

  if (to && data) {
    return {
      to,
      data,
      value: value?.toString() || '',
    }
  }

  return null
}

export const resolveAllThirdwebTransactions = async (
  thirdwebTxs?: PreparedTransaction[]
): Promise<TransactionBase[]> => {
  if (!thirdwebTxs) return []
  const resolvedTxs = await Promise.all(
    thirdwebTxs.map(tx => resolveThirdwebTransaction(tx))
  )
  return resolvedTxs.filter(
    (tx): tx is TransactionBase => tx !== null && tx !== undefined
  )
}
